import moment from 'moment';

const language = localStorage.getItem('language');

export const handleDateLocale = date => {
  if (language === 'en') {
    moment.locale('en');
    return moment(date).format('ll');
  } else if (language === 'jp') {
    moment.locale('ja');
    return moment(date).format('YYYY[年]MMMMDo');
  } else if (language === 'vi') {
    moment.locale('vi');
    return moment(date).format('DD/MM/YYYY');
  }
};
